module.exports = __webpack_public_path__ + "img/vnftLogo.b51960e7.svg";